import type { QuoteReponse } from "@/shared/http/lead-api"
import { ROUTES } from "@/shared/routing/routes"

export function computeRedirectRoute(quoteResponse: QuoteReponse): string {
  const pets = quoteResponse.data
  const owner = quoteResponse.pet_owner
  const hasAnyFormula = pets.some((p) => p.options || p.coverage)
  const allPetsHaveFormula = pets.every((p) => p.options || p.coverage)

  // CONVERSION: at least one pet has a formula
  if (hasAnyFormula) {
    if (!allPetsHaveFormula) return ROUTES.coverage.path
    if (owner?.owner_birthday) return ROUTES.recap.path
    return ROUTES.tribeQuote.path
  }

  // LEAD GENERATION: no formula yet
  // A real email means the user passed /attributionQuestion + /userMailPhone
  // and is ready for formula selection.
  // "_" is the backend placeholder when a landing page created the quote
  // without asking for an email, so treat it as "no email entered".
  if (owner?.owner_email && owner.owner_email !== "_") return ROUTES.coverage.path
  return ROUTES.tribe.path
}
